import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["id", "domain"];
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useQueries } from 'react-query';

// ListDisplayPrices accepts at most 50 domains per call.
const MAX_DOMAINS_PER_BATCH = 50;
const chunk = (items, size) => Array.from({
  length: Math.ceil(items.length / size)
}, (_, i) => items.slice(i * size, (i + 1) * size));
const toPricedDomains = recommendations => recommendations.filter(rec => !!rec.domain).map(_ref => {
  let domain = _ref.domain,
    premium = _ref.premium;
  return {
    domain,
    premium: premium ?? false
  };
});

/**
 * Resolves display prices for already-loaded recommendations, so pricing can be
 * fetched lazily instead of inflating the `listRecommendations` call with the
 * PRICING feature (mirrors how `useMatchingLabels` resolves labels afterwards).
 */
export const useDisplayPrices = (recommendationBatches, productType) => {
  var _results$find;
  const _DomainsApiClient$use = DomainsApiClient.useQueries(),
    listDisplayPrices = _DomainsApiClient$use.listDisplayPrices;
  const batches = recommendationBatches.map(toPricedDomains).filter(domains => domains.length > 0);
  const priceQueries = batches.map(domains => ({
    queryKey: ['listDisplayPrices', domains, productType],
    staleTime: Infinity,
    cacheTime: Infinity,
    retry: false,
    refetchOnMount: false,
    queryFn: async () => {
      var _responses$;
      const responses = await Promise.all(chunk(domains, MAX_DOMAINS_PER_BATCH).map(batch => listDisplayPrices({
        domains: batch,
        ...(productType ? {
          productType: {
            domainProductType: productType
          }
        } : {})
      })));
      const pricesByDomain = new Map();
      responses.flatMap(res => res.displayPrices ?? []).forEach(_ref2 => {
        let id = _ref2.id,
          domain = _ref2.domain,
          price = _objectWithoutPropertiesLoose(_ref2, _excluded);
        const key = domain ?? id;
        if (key) {
          // display-price and recommendation share an identical DisplayPrice
          // shape, but are distinct generated ambassador types.
          pricesByDomain.set(key, price);
        }
      });
      return {
        pricesByDomain,
        pricesExcludeTax: (_responses$ = responses[0]) == null ? void 0 : _responses$.pricesExcludeTax
      };
    }
  }));
  const results = useQueries(priceQueries);
  const pricesByDomain = new Map();
  results.forEach(_ref3 => {
    let data = _ref3.data;
    return data == null ? void 0 : data.pricesByDomain.forEach((price, domain) => pricesByDomain.set(domain, price));
  });
  return {
    pricesByDomain,
    isLoading: results.some(_ref4 => {
      let isLoading = _ref4.isLoading;
      return isLoading;
    }),
    pricesExcludeTax: (_results$find = results.find(_ref5 => {
      let data = _ref5.data;
      return data;
    })) == null || (_results$find = _results$find.data) == null ? void 0 : _results$find.pricesExcludeTax
  };
};
//# sourceMappingURL=useDisplayPrices.js.map